export default __webpack_public_path__ + "static/media/m-sub-banner-right-2.80af50b8.svg";